import React, { useEffect } from "react";
import './App.css';
import './HomePage.css';
import { Routes, Route, useLocation } from 'react-router-dom';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function ShowPage() {
  const query = useQuery();
  const title = query.get('title') || '';
  const cover = query.get('cover');
  const utm_source = query.get('utm_source');
  const utm_medium = query.get('utm_medium');
  const utm_campaign = query.get('utm_campaign');
  const utm_content = query.get('utm_content');
  const utm_term = query.get('utm_term');
  const deeplink = query.get('deeplink');

  const params = {
    utm_source: utm_source,
    utm_medium: utm_medium,
    utm_campaign: utm_campaign,
    utm_content: utm_content,
    utm_term: utm_term,
    deeplink: deeplink,
  };

  const referrer = Object.entries(params)
    .filter(([_, v]) => v !== null)
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&');

  const gpUrl = `https://play.google.com/store/apps/details?id=com.telereels.app.android&referrer=${encodeURIComponent(referrer)}`;
  const iosUrl = "https://apps.apple.com/app/id6636523706";

  const downloadUrl = isIOS() ? iosUrl : gpUrl;

  return (
    <div className="App">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="show-title">{title}</h1>
          <div className="show-cover-large" style={cover ? { background: `none` } : {}}>
            {cover ? (
              <img
                src={cover}
                alt={title}
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '20px' }}
              />
            ) : null}
            <div className="show-overlay">
              <span className="play-icon">▶</span>
            </div>
          </div>
        </div>
      </section>

      {/* Floating Download Bar */}
      <div className="floating-download-bar">
        <div className="download-content">
          <div className="app-info">
            <img className="app-icon" src="/images/icon.png" alt="Logo" />
            <div className="app-details">
              <div className="app-name">TeleReels - Drama Cortos & TV</div>
              <div className="app-rating">⭐⭐⭐⭐⭐ 4.8分</div>
            </div>
          </div>
          <div className="download-actions">
            <a
              className="download-btn"
              href={downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                window.fbq('trackCustom', 'download_btn_click');
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                fill="currentColor"
                viewBox="0 0 16 16"
                style={{ marginRight: '6px', verticalAlign: 'middle' }}
              >
                <path d="M4.5 3.5v9l7-4.5-7-4.5z" />
              </svg>
              Continuar viendo
            </a>
            <div className="download-tip">Confiado por 1 millón de usuarios</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function HomePage() {
  return (
    <div className="homepage-container">
      <div style={{ textAlign: 'center' }}>
        <img src={"/images/icon.png"} alt="TeleReels" className="homepage-logo" />
        <div className="homepage-title">TeleReels</div>
        <div className="homepage-desc">Telenovelas cortas, pasión y drama en cualquier momento</div>
        <div className="homepage-btn-row">
          <a href="https://play.google.com/store/apps/details?id=com.telereels.app.android" className="homepage-badge-btn" target="_blank" rel="noopener noreferrer">
            <img src={"/badges/google-play-badge.png"}
              alt="Google Play"
              style={{ height: 40, width: 'auto', display: 'block', borderRadius: 6, boxShadow: '0 2px 8px rgba(90,81,254,0.08)' }} />
          </a>
          <a href="https://apps.apple.com/app/id6636523706" className="homepage-badge-btn" target="_blank" rel="noopener noreferrer">
            <img src={"/badges/ios-badge.svg"}
              alt="App Store"
              style={{ height: 40, width: 'auto', display: 'block', borderRadius: 6, boxShadow: '0 2px 8px rgba(90,81,254,0.08)' }} />
          </a>
        </div>
      </div>
      <div className="homepage-section">
        <div className="homepage-screenshot-row">
          <img src={"/screenshots/1.png"} alt="screenshot1" className="homepage-screenshot" />
          <img src={"/screenshots/2.png"} alt="screenshot2" className="homepage-screenshot" />
          <img src={"/screenshots/3.png"} alt="screenshot3" className="homepage-screenshot" />
          <img src={"/screenshots/4.png"} alt="screenshot4" className="homepage-screenshot" />
        </div>
      </div>
      <div className="homepage-section">
        <div className="homepage-section-title">Acerca de</div>
        <div style={{ marginBottom: 8 }}>Contáctenos: <a href="mailto:contact@telereels.com">contact@telereels.com</a></div>
        <div style={{ marginBottom: 8 }}><a href="https://telereels.com/privacy">Política de privacidad</a></div>
        <div style={{ marginBottom: 8 }}><a href="https://telereels.com/terms">Términos de servicio</a></div>
        <div>Dirección: 113 N San Vicente Blvd, Beverly Hills, CA 90211, United States</div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/landing/show" element={<ShowPage />} />
    </Routes>
  );
}

export default App;
